<template>
    <v-container :fluid="$vuetify.breakpoint.md" class="mb-12 mb-lg-0">
        <v-row justify="center">
            <v-col>
                <v-card width="100%">
                    <v-card-title class="d-block text-center font-weight-bold primary white--text pa-1" style="word-break: normal">RECOMPENSAS</v-card-title>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import axios from 'axios';

export default {
    name: "Rewards",
    props: [ 'user' ],
    data: () => ({}),
    mounted() {
        this.getData();
    },
    methods: {
        getData() {}
    }
}
</script>

<style scoped>

</style>
